import { SAVE_COGNITO_USER } from '../actions/CognitoUser';

const initialState = { cognitoUserId: '' };

const cognitoUser = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_COGNITO_USER:
      return {
        cognitoUserId: action.payload
      };
    default:
      return state;
  }
};

export default cognitoUser;
